import { getBadgeVariant } from "../constants/policyConstants";

const policyFitPillarScoreBands = {
  incomeAffordability: {
    Weak: { min: 0, max: 49.99 },
    Medium: { min: 50, max: 69.99 },
    Strong: { min: 70, max: 100 },
  },

  employmentStability: {
    Weak: { min: 0, max: 54.99 },
    Medium: { min: 55, max: 74.99 },
    Strong: { min: 75, max: 100 },
  },

  financialBehaviour: {
    Weak: { min: 0, max: 49.99 },
    Medium: { min: 50, max: 74.99 },
    Strong: { min: 75, max: 100 },
  },

  creditDefaultRisk: {
    Weak: { min: 0, max: 59.99 },
    Medium: { min: 60, max: 79.99 },
    Strong: { min: 80, max: 100 },
  },

  documentationStrength: {
    Weak: { min: 0, max: 64.99 },
    Medium: { min: 65, max: 84.99 },
    Strong: { min: 85, max: 100 },
  },
};

const PILLAR_STATUS_ORDER = ["Weak", "Medium", "Strong"];

export const PILLAR_STATUS_LABEL_KEYS = {
  Weak: "pillarStatusWeak",
  Medium: "pillarStatusMedium",
  Strong: "pillarStatusStrong",
};

export const PILLAR_TITLE_KEYS = {
  incomeAffordability: "pillarTitleIncomeAffordability",
  employmentStability: "pillarTitleEmploymentStability",
  financialBehaviour: "pillarTitleFinancialBehaviour",
  creditDefaultRisk: "pillarTitleCreditDefaultRisk",
  documentationStrength: "pillarTitleDocumentationStrength",
};

export const PILLAR_NO_DATA_KEY = "pillarStatusNoData";

export const getPillarStatusFromScore = (pillarKey, score) => {
  const numericScore = Number(score);
  const bands = policyFitPillarScoreBands[pillarKey];

  if (!bands || Number.isNaN(numericScore)) return null;

  const strongBand = bands.Strong;
  if (strongBand && numericScore > strongBand.max) return "Strong";

  for (const status of PILLAR_STATUS_ORDER) {
    const range = bands[status];
    if (!range) continue;
    if (numericScore >= range.min && numericScore <= range.max) return status;
  }

  const weakBand = bands.Weak;
  if (weakBand && numericScore < weakBand.min) return "Weak";

  return null;
};

export const getPillarBadgeFromScore = (pillarKey, score) => {
  const status = getPillarStatusFromScore(pillarKey, score);

  if (!status) {
    return {
      labelKey: PILLAR_NO_DATA_KEY,
      variant: "neutral",
      status: null,
    };
  }

  return {
    labelKey: PILLAR_STATUS_LABEL_KEYS[status] || PILLAR_NO_DATA_KEY,
    variant: getBadgeVariant(status),
    status,
  };
};
